import React, { useState } from "react";
import { Button, TextField, InputAdornment, IconButton } from "@mui/material";
import { message } from "antd";
import { auth, setDoc, db, doc,getDoc } from "../../firebase";
import { useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import './RegisterStep.css'

const RegisterStep2 = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const [usernameExists, setUsernameExists] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    reUsername: "",
    password: "",
    rePassword: "",
    loginCode: "",
  });

  const navigate = useNavigate();

  const phone = localStorage.getItem("userPhone");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUsernameBlur = async (e) => {
    const username = e.target.value.trim();
    if (username) {
      const userDoc = doc(db, "users", username);
      const docSnap = await getDoc(userDoc);
      if (docSnap.exists()) {
        setUsernameExists(true);
        message.error("Username already exists");
      } else {
        setUsernameExists(false);
      }
    }
  };

  const handleSubmit = async () => {
    if (formData.password !== formData.rePassword) {
      message.error("Passwords do not match");
      return;
    }

    if (formData.username !== formData.reUsername) {
      message.error("Usernames do not match");
      return;
    }

    try {
      const userDoc = doc(db, "users", formData.username);
      await setDoc(userDoc, {
        ...userInfo,
        username: formData.username,
        password: formData.password,
        loginCode: formData.loginCode,
        phone,
      });

      message.success("Registration successful");
      localStorage.setItem("username", formData.username); 
      localStorage.setItem("password", formData.password); 

      navigate("/login");
    } catch (err) {
      console.error("Error during registration: ", err);
      message.error("Something went wrong");
    }
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowRePassword = () => setShowRePassword((show) => !show);

  return (
    <div className="register-container">
      <div className="register-form-container">
        <form>
          <div className="form-description">
            <h3>REGISTER: Step 2</h3>
          </div>

          <TextField
              name="username"
              label="Create Username"
              value={formData.username}
              onChange={handleChange}
              onBlur={handleUsernameBlur}
              fullWidth
              margin="normal"
              required
              error={usernameExists}
              helperText={usernameExists ? "Username exists" : ""}
            />
          <TextField
            name="reUsername"
            label="Re-enter Username"
            value={formData.reUsername}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />

          <TextField
            name="password"
            label="Create Password"
            type={showPassword ? "text" : "password"}
            value={formData.password}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            name="rePassword"
            label="Re-enter Password"
            type={showRePassword ? "text" : "password"}
            value={formData.rePassword}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowRePassword}
                  >
                    {showRePassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            name="loginCode"
            label="Login Code (optional)"
            value={formData.loginCode}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            fullWidth
          >
            Register
          </Button>
        </form>
      </div>
    </div>
  );
};

export default RegisterStep2;
